import React from "react";
import Container from "@mui/material/Container";
import { Typography } from "@mui/joy";
import info from "../content/info.json";
import JobCard from "../components/home/JobCard";
import EduCard from "../components/home/EduCard";

const Portfolio = () => (
  <>
    <Container
      sx={{
        paddingTop: "2rem",
      }}
    >
      <Typography level="body-md">{info.bio}</Typography>
      <Typography level="h3" sx={{ mt: "2rem", mb: "1rem" }}>
        Experience
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
          overflowX: "auto",
        }}>
        {info.jobs.map((job) => (
          <JobCard job={job} />
        ))}
      </div>
      <Typography level="h3" sx={{ mt: "2rem", mb: "1rem" }}>
        Education
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
          overflowX: "auto",
        }}>
        {info.education.map((school) => (
          <EduCard school={school} />
        ))}
      </div>
    </Container>
  </>
);

export default Portfolio;
